<div *ngIf="visible" class="subscription-success-backdrop">
  <div class="subscription-success-modal">
    <div class="subscription-success-icon">
      <ng-lottie width="80px" height="80px" [options]="lottieOptions"></ng-lottie>
    </div>
    <h2 class="subscription-success-title">¡Suscripción activada!</h2>
    <p class="subscription-success-message">
      Tu suscripción se ha activado correctamente. Ya puedes usar tu plan y seguir creciendo con Globot.
    </p>
    <button class="subscription-success-button" type="button" (click)="onClose()">
      Entendido
    </button>
  </div>
</div>

